/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiResponse1BasicModelResponse,
  ApiResponse1IEnumerable1,
  ApiResponse1Object,
  RevisdomAPIViewModelsOrganizationCreateOrganizationRequest,
} from '../models/index';
import {
    ApiResponse1BasicModelResponseFromJSON,
    ApiResponse1BasicModelResponseToJSON,
    ApiResponse1IEnumerable1FromJSON,
    ApiResponse1IEnumerable1ToJSON,
    ApiResponse1ObjectFromJSON,
    ApiResponse1ObjectToJSON,
    RevisdomAPIViewModelsOrganizationCreateOrganizationRequestFromJSON,
    RevisdomAPIViewModelsOrganizationCreateOrganizationRequestToJSON,
} from '../models/index';

export interface ApiOrganizationPostRequest {
    revisdomAPIViewModelsOrganizationCreateOrganizationRequest?: RevisdomAPIViewModelsOrganizationCreateOrganizationRequest;
}

/**
 * 
 */
export class OrganizationApi extends runtime.BaseAPI {

    /**
     * **Required Roles:** AccountManager, SuperAdmin  Bu endpoint sadece AccountManager ve SuperAdmin rolündeki kullanıcılar tarafından kullanılabilir.
     * Tüm organizasyonları getirir
     */
    async apiOrganizationListGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1IEnumerable1>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Organization/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1IEnumerable1FromJSON(jsonValue));
    }

    /**
     * **Required Roles:** AccountManager, SuperAdmin  Bu endpoint sadece AccountManager ve SuperAdmin rolündeki kullanıcılar tarafından kullanılabilir.
     * Tüm organizasyonları getirir
     */
    async apiOrganizationListGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1IEnumerable1> {
        const response = await this.apiOrganizationListGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** AccountManager, SuperAdmin  Bu endpoint sadece AccountManager ve SuperAdmin rolündeki kullanıcılar tarafından kullanılabilir.
     * Yeni bir organizasyon oluşturur
     */
    async apiOrganizationPostRaw(requestParameters: ApiOrganizationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1BasicModelResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Organization`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsOrganizationCreateOrganizationRequestToJSON(requestParameters['revisdomAPIViewModelsOrganizationCreateOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1BasicModelResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** AccountManager, SuperAdmin  Bu endpoint sadece AccountManager ve SuperAdmin rolündeki kullanıcılar tarafından kullanılabilir.
     * Yeni bir organizasyon oluşturur
     */
    async apiOrganizationPost(requestParameters: ApiOrganizationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1BasicModelResponse> {
        const response = await this.apiOrganizationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
